<template>
  <div>
    <!-- https://joaomede.github.io/vue3-xlsx/guide/#quick-start -->
    <div class="excelImport-form">
      <p>Wybierz plik Excel i powiąż kolumny z danymi:</p>

      <hr/>

      <!--        add preferredIdentifierOptions select box:-->
      <div class="form-group">
        <label for="preferred-identifier-select">Preferowany identyfikator kategorii (używany do aktualizacji
          istniejących kategorii)</label>
        <select
            :class="preferredIdentifierInputClass"
            v-model="preferredIdentifier"
            id="preferred-identifier-select"
            class="form-control"
            aria-describedby="preferred-identifier-feedback"
            required
        >
          <option :value="null" disabled>Wybierz preferowany identyfikator kategorii, aby umożliwić wybór pliku</option>
          <option
              v-for="option in preferredIdentifierOptions"
              :key="option.key"
              :value="option.key"
          >
            {{ option.text }}
          </option>
        </select>
        <div
            class="invalid-feedback"
            id="preferred-identifier-feedback"
        >
          Wybór preferowanego identyfikatora jest wymagany.

        </div>

      </div>


      <section>
        <input
            type="file"
            @change="onFileChange"
            :class="fileInputClass"
            id="excelImport-file-input"
            aria-describedby="excelImport-file-input-feedback"
            placeholder="Kliknij aby wybrać plik do importu"
            title="Kliknij aby wybrać plik do importu"
            accept=".xls,.xlsx,.csv,.odf,.ods,.odt,.docx"
            :disabled="!preferredIdentifier"
        />
        <div class="invalid-feedback" id="excelImport-file-input-feedback">
          Nie wybrano pliku do importu
        </div>

        <xlsx-read :file="file">
          <xlsx-sheets>
            <template #default="{ sheets }">
              <div v-show="selectSheetVisible" class="row excelImport-form-row">
                <div class="col">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Wybierz arkusz danych</div>
                    </div>
                    <select
                        v-model="selectedSheet"
                        aria-describedby="excelImport-sheet-input-feedback"
                        @click="sheetIsSelected"
                        :class="selectedSheetInputClass"
                        required
                        :disabled="!preferredIdentifier"
                    >
                      <option disabled selected="selected">
                        Zaimportowane arkusze:
                      </option>
                      <option v-for="sheet in sheets" :key="sheet" :value="sheet">
                        {{ sheet }}
                      </option>
                    </select>
                    <div
                        class="invalid-feedback"
                        id="excelImport-sheet-input-feedback"
                    >
                      Nie wybrano pliku arkusza danych
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </xlsx-sheets>
          <button
              class="btn btn-success"
              @click="parseXlsxData"
              :disabled="importActionButtonDisabled"
          >
            Powiąż pola danych
          </button>
          <hr/>
          <!-- <xlsx-table :sheet="selectedSheet"/> -->
          <div v-if="xlsxDataParsing">
            <xlsx-json :sheet="selectedSheet">
              <template #default="{ collection }">
                <div>
                  {{ getXlsxJson(collection) }}
                </div>
              </template>
            </xlsx-json>
          </div>
        </xlsx-read>


      </section>
    </div>


    <div>

      <hr/>

      <div
          class="alert alert-danger"
          role="alert"
          v-show="importedDataErrorDisplayed"
      >
        {{ importedDataErrorMessage }}
      </div>

    </div>

    <!-- Xlsx content table modal -->
    <div v-if="xlsxContentDisplayed" class="modal">
      <div
          class="modal-content"
          ref="excelImport-bind-modal-form"
          id="excelImport-bind-modal-form"
      >

        <button class="btn btn-primary" @click="closeFieldsBindingForm">
          Zapisz mapowanie
        </button>
        <h3>Arkusz powiązywania pól danych</h3>

        <div class="table-responsive">
          <div
              class="alert alert-warning"
              role="alert"
              v-show="duplicatedMappingWarningDisplayed"
          >
            Wykryto zduplikowane wartości mapowanych pól. Bez zmian kolejne
            wartości nadpiszą wcześniejsze mapowanie.
          </div>

          <table class="table table-hover table-bordered">
            <thead>
            <tr>
              <th
                  v-for="(recordKey, index) in availableRecordsKeys"
                  :key="index"
              >
                <div>
                  <select :ref="'field_' + index" @change="getMapping" required>
                    <option
                        v-if="columnMapped(index)"
                        selected="selected"
                        :value="excelFileAvailableKeysMapReversed[columnsMapping[index]]"
                    >
                      {{ columnsMapping[index] }}
                    </option>


                    <option v-else selected="selected" :value="undefined">
                      Przypisz pole...
                    </option>

                    <option
                        v-for="field in excelFileAvailableKeysMap"
                        :key="field"
                        :value="field"
                    >
                      {{ field }}
                    </option>
                  </select>
                </div>
                <hr/>
                <div :ref="'jsonKey_' + index">
                  {{ availableRecordsKeys[index] }}
                  {{ addColumnIndex(index) }}
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="record in records.slice(
                0,
                visibleRecordsCountDuringImport,
              )"
                :key="record"
            >
              <td v-for="key in availableRecordsKeys" :key="key">
                {{ record[key] }}
              </td>
            </tr>
            </tbody>
          </table>
          <button
              type="button"
              class="btn btn-light"
              style="width: 100%; margin-bottom: 10px"
              @click="changeVisibleRecordCount"
          >
            <!--          <font-awesome-icon :icon="chevronIcon"/>-->
            {{ changeVisibleRecordCountButtonValue }}
          </button>
          <br/>
        </div>
        <button
            class="btn btn-danger"
            @click="cancelMapping"
            style="width: 200px"
        >
          Anuluj mapowanie
        </button>
      </div>

    </div>


    <button v-if="applyBtnTitle" class="btn btn-primary" @click="saveData">
      {{ applyBtnTitle }}
    </button>

  </div>

</template>
<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import {XlsxRead, XlsxSheets, XlsxJson} from "vue3-xlsx";
import Swal from "sweetalert2";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "@/state/pinia/log";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export default {
  name: "CategoryTreeExcelImportForm",
  props: {
    applyBtnTitle: String,
    orderToDivide: Boolean,
  },
  emits: ['onSave','onPreferredIdentifierChange'],
  components: {
    XlsxRead,
    XlsxSheets,
    XlsxJson
  },
  data() {
    return {
      file: null,
      selectedSheet: null,
      sheetName: null,
      sheets: [{name: "SheetOne", data: [{c: 2}]}],
      collection: [{a: 1, b: 2}],
      records: [],
      availableRecordsKeys: [],
      importActionButtonDisabled: true,
      xlsxContentDisplayed: false,
      xlsxDataParsing: false,
      visibleRecordsCountDuringImport: 6,
      changeVisibleRecordCountButtonValue:
          " Pokaż wszystkie importowane rekordy",
      chevronIcon: "chevron-down",
      jsonKeyMapList: [],
      jsonKeyMap: {},
      columnIndexes: [],
      columnsMapping: {},
      duplicatedMappingWarningDisplayed: false,

      fileInputClass: "form-control",
      selectedSheetInputClass: "form-control",

      selectSheetVisible: false,
      importedDataErrorDisplayed: false,
      importedDataErrorMessage: "",
      preferredIdentifierOptions: [
        {key: "ID", text: "ID kategorii"},
        {key: "GUID", text: "GUID kategorii"},
        {key: "NAME", text: "Nazwa kategorii"},
      ],
      preferredIdentifier: null,
      preferredIdentifierInputClass: "form-control",

      draggable: false,
      excelFileAvailableKeysMap: {},
      excelFileAvailableKeysMapReversed: {},
      availableFileFormatsToImport: [
        "xls",
        "xlsx",
        "csv"
      ],

    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    onApplyData() {
      console.log("OnApplyData triggered from CategoryTreeExcelImportForm")
      return this.saveData()
    },
  },

  methods: {

    changeVisibleRecordCount() {
      if (this.visibleRecordsCountDuringImport === this.records.length) {
        this.changeVisibleRecordCountButtonValue =
            "  Pokaż wszystkie importowane rekordy";
        this.chevronIcon = "chevron-down";
        this.visibleRecordsCountDuringImport = 6;
      } else {
        this.changeVisibleRecordCountButtonValue =
            "  Pokaż tylko pierwsze rekordy";
        this.chevronIcon = "chevron-up";
        this.visibleRecordsCountDuringImport = this.records.length;
      }
    },
    getXlsxJson(jsonCollection) {
      this.records = null;
      this.records = jsonCollection;
      if (this.records != null) {
        // preparing json data for transforamtion
        var recordsKeysArray = this.records.map((record) =>
            Object.keys(record)
        );
        var recordsKeysCountArray = this.records.map(
            (record) => Object.keys(record).length
        );
        var maxKeysCount = Math.max.apply(null, recordsKeysCountArray);
        for (let i = 0; i < recordsKeysArray.length; i++) {
          if (recordsKeysArray[i].length === maxKeysCount) {
            this.availableRecordsKeys = recordsKeysArray[i];
            break;
          }
        }
      }

      // And when finished
      this.xlsxContentDisplayed = true;
    },
    parseXlsxData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.initColumnMappingDialog().then(() => {
        this.importedDataErrorDisplayed = false;
        this.xlsxDataParsing = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);
      })
    },
    showXlsxContentTable() {
      this.importedDataErrorDisplayed = false;
      this.xlsxContentDisplayed = true;

    },
    addColumnIndex(index) {
      this.columnIndexes.push(index);
    },
    getMapping() {
      for (var index in this.columnIndexes) {
        var field = this.$refs["field_" + index];

        if (field && field.length > 0) {
          var field0Value = field[0][field[0].selectedIndex].value;
          var fieldToMap = this.excelFileAvailableKeysMapReversed[field0Value];
          var jsonKey = this.$refs["jsonKey_" + index];
          if (jsonKey && jsonKey.length > 0 && jsonKey[0].firstChild) {
            var jsonKeyValue = jsonKey[0].firstChild.data;

            if (fieldToMap && jsonKeyValue) {
              // Adding column mapping to be capable to display it second time when user opens import form for particular import
              this.columnsMapping[index] = field0Value;
              this.checkDuplicatedMapping(fieldToMap);
              this.jsonKeyMap[fieldToMap] = jsonKeyValue.toString().trim();
            }
          }
        }
      }
      log.log("Mapping finished:")
      log.log(this.jsonKeyMap);


    },
    checkDuplicatedMapping(field) {
      if (this.fieldIsAlreadyInObject(field, this.jsonKeyMap)) {
        this.duplicatedMappingWarningDisplayed = true;
      } else {
        this.duplicatedMappingWarningDisplayed = false;
      }
    },
    fieldIsAlreadyInObject(field, obj) {
      for (var i = 0; i < Object.keys(obj).length; i++) {
        if (Object.keys(obj)[i] === field) {
          return true;
        }
      }
      return false;
    },
    columnMapped(index) {
      if (this.columnsMapping[index] !== undefined) {
        return true;
      }

      var matchedValue = this.matchColumnMapping(index);
      if (matchedValue) {
        //get name of column name/drugstore id (it can be found in orderFileAvailableKeysMap)
        var keyFound = this.excelFileAvailableKeysMap[matchedValue]
        this.columnsMapping[index] = keyFound
        var reversedKey = this.excelFileAvailableKeysMapReversed[keyFound]

        const columnFetchedKeyValue = this.availableRecordsKeys[index]
        this.jsonKeyMap[reversedKey] = columnFetchedKeyValue
        return true;
      }


      return false;
    },
    matchColumnMapping(columnIndex) {
      // we are about to check fetched table keys and first two rows if have any values that we can map with available keys
      // 1. Checking columns fetched by ve xlsx lib as column keys
      var keyFound = null;
      const columnFetchedKeyValue = this.availableRecordsKeys[columnIndex]
      var foundValue = null;
      if (columnFetchedKeyValue) {
        keyFound = Object.keys(this.excelFileAvailableKeysMapReversed).find((key) => {
          if (columnFetchedKeyValue.toString().toLowerCase().startsWith(key.toString().toLowerCase())) {
            return key;
          }
        });
        if (keyFound) {
          foundValue = this.excelFileAvailableKeysMapReversed[keyFound];
        }

        if (foundValue) {
          return foundValue;
        }
      }

      // 2. Checking first row
      const firstRow = this.records[0];
      const keyFirstOnIndex = Object.keys(firstRow)[columnIndex];
      const firstRowOfColIndexValue = firstRow[keyFirstOnIndex];
      foundValue = null;
      if (!firstRowOfColIndexValue) {
        return foundValue;
      }

      keyFound = Object.keys(this.excelFileAvailableKeysMapReversed).find((key) => {
        if (firstRowOfColIndexValue.toString().toLowerCase().startsWith(key.toString().toLowerCase())) {
          return key;
        }
      });
      if (keyFound) {
        foundValue = this.excelFileAvailableKeysMapReversed[keyFound];
      }

      // 2. Checking second row
      if (!foundValue) {
        const secondRow = this.records[1];
        const keySecondOnIndex = Object.keys(secondRow)[columnIndex];
        const secondRowOfColIndexValue = secondRow[keySecondOnIndex];
        if (!secondRowOfColIndexValue) {
          return foundValue;
        }


        keyFound = Object.keys(this.excelFileAvailableKeysMapReversed).find((key) => {
          if (secondRowOfColIndexValue.toString().toLowerCase().startsWith(key.toString().toLowerCase())) {
            return key;
          }
        });
        if (keyFound) {
          foundValue = this.excelFileAvailableKeysMapReversed[keyFound];
        }
      }

      return foundValue;

    },

    saveData() {
      if (!this.checkForm()) {
        return null;
      }
      // adding header row as data row - we do not want to avoid first row of excel file
      if (this.records.length > 0) {
        var headerRowAsDataRow = {};
        for (const headerKey of Object.keys(this.records[0])) {
          headerRowAsDataRow[headerKey] = headerKey;
        }
        this.records.push(headerRowAsDataRow);
      }

      var fetchedItems = []
      //Transforming row data
      for (const recordIndex in this.records) {
        // Clearing every record object keys from empty spacies
        for (const recordKey in this.records[recordIndex]) {
          var oldKey = recordKey;
          var newKey = recordKey.toString().trim();
          if (oldKey !== newKey) {
            Object.defineProperty(
                this.records[recordIndex],
                newKey,
                Object.getOwnPropertyDescriptor(this.records[recordIndex], oldKey)
            );
            delete this.records[recordIndex][oldKey];
          }
        }

        var orderItemObject = {};
        for (const jsonKey in this.jsonKeyMap) {
          // log.log(`${jsonKey} = ${this.jsonKeyMap[jsonKey]}`);
          var originalObject = this.records[recordIndex];
          var value =
              originalObject[this.jsonKeyMap[jsonKey].toString().trim()];
          if (value) {
            if (this.valueIsNotNumber(value)) {
              orderItemObject[jsonKey] = value;
            } else {
              // value is a number, so let`s check what kind of number is it, and cast it into correct type
              if (
                  /^\d*[.]\d+$/.test(value.toString()) ||
                  /^\d*[,]\d+$/.test(value.toString())
              ) {
                orderItemObject[jsonKey] = parseFloat(value.toString());
              } else {
                orderItemObject[jsonKey] = parseInt(value.toString());
              }
            }
          }
        }

        const productInCategoryRecord = {
          id: orderItemObject["id"] ? Number(orderItemObject["id"]) : 0,
          guid: orderItemObject["guid"] ? orderItemObject["guid"] : null,
          name: orderItemObject["name"] ? orderItemObject["name"] : null,
          parentCategoryId: orderItemObject["parentCategoryId"] ? Number(orderItemObject["parentCategoryId"]) : 0,
          parentCategoryGuid: orderItemObject["parentCategoryGuid"] ? orderItemObject["parentCategoryGuid"] : null,
          parentCategoryPath: orderItemObject["parentCategoryPath"] ? orderItemObject["parentCategoryPath"] : null,
          description: orderItemObject["description"] ? orderItemObject["description"] : null,
          orderIndex: orderItemObject["orderIndex"] ? orderItemObject["orderIndex"] : null,
          createdAt: orderItemObject["createdAt"] ? orderItemObject["createdAt"] : null,
          updatedAt: orderItemObject["updatedAt"] ? orderItemObject["updatedAt"] : null,
          type: orderItemObject["type"] ? orderItemObject["type"] : null,
          isRemoved: orderItemObject["isRemoved"] ? orderItemObject["isRemoved"] : false,
          isCentralCategory: orderItemObject["isCentralCategory"] ? orderItemObject["isCentralCategory"] : false,
          productBloz: orderItemObject["productBloz"] ? orderItemObject["productBloz"].toString() : null,
          productEan: orderItemObject["productEan"] ? orderItemObject["productEan"] : null,
          productName: orderItemObject["productName"] ? orderItemObject["productName"] : null,
          productBarcode: orderItemObject["productBarcode"] ? orderItemObject["productBarcode"] : null,
        };

        // Adding parsed order item to list
        fetchedItems.push(productInCategoryRecord)
      }

      var exportPayload = {
        items: fetchedItems,
        file: this.file
      };

      this.$emit("onSave", exportPayload)
      return exportPayload;

    },

    checkForm() {
      var isValid = true;
      var notValidFieldsCount = 0;
      console.log("Checking form...")
      console.log(this.preferredIdentifier)
      if (!this.preferredIdentifier) {
        this.preferredIdentifierInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.preferredIdentifierInputClass = "form-control";
      }

      if (!this.file) {
        this.fileInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.fileInputClass = "form-control";
      }

      if (!this.selectedSheet) {
        this.selectedSheetInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.selectedSheetInputClass = "form-control";
      }

      if (this.records.length === 0) {
        this.importedDataErrorDisplayed = true;
        this.importedDataErrorMessage = "Brak danych w arkuszu";
        notValidFieldsCount++;
      } else {
        this.importedDataErrorDisplayed = false;
        this.importedDataErrorMessage = "";
      }
      if (!this.jsonKeyMap || Object.keys(this.jsonKeyMap).length === 0) {
        this.importedDataErrorDisplayed = true;
        this.importedDataErrorMessage =
            "Nie powiązano żadnych pól w zaimportowanych danych";

        notValidFieldsCount++;
      } else {
        this.importedDataErrorDisplayed = false;
        this.importedDataErrorMessage = "";
      }

      if (notValidFieldsCount > 0) {
        isValid = false;
      } else {
        isValid = true;
      }

      return isValid;
    },
    valueIsNotNumber(value) {
      if (value === null || value === undefined) {
        value = 0.0;
      }

      if (value.toString()[0] === "-") {
        return (
            !/^[-]\d*[.]\d+$/.test(value.toString()) &&
            !/^[-]\d*[,]\d+$/.test(value.toString()) &&
            !/^[-]\d+$/.test(value.toString())
        );
      } else {
        return (
            !/^\d*[.]\d+$/.test(value.toString()) &&
            !/^\d*[,]\d+$/.test(value.toString()) &&
            !/^\d+$/.test(value.toString())
        );
      }
    },

    onFileChange(event) {
      var fileToParse = event.target.files ? event.target.files[0] : null;
      var fileFormat = this.getFileFormat(fileToParse);
      this.file = fileToParse;
      this.validateFileFormat(fileToParse, fileFormat);
      // Reseting all fields
      this.sheetName = null;
      this.selectedSheet = null;
      this.sheets = [{name: "SheetOne", data: [{c: 2}]}];
      this.collection = [{a: 1, b: 2}];
      this.records = [];
      this.xlsxDataParsing = false;
      this.availableRecordsKeys = [];
      this.importActionButtonDisabled = true;
      this.xlsxContentDisplayed = false;
      this.selectSheetVisible = true;
      this.fileInputClass = "form-control";
      this.jsonKeyMap = {};
      this.columnsMapping = {};
    },

    validateFileFormat(file, fileFormat) {
      if (file != null && file.name.length > 0) {
        var formatAvailable = this.isFileFormatAvailable(fileFormat);
        if (!formatAvailable) {
          Swal.fire(
              "Format pliku jest nieprawidłowy!",
              "Dopuszczalne formaty plików to: " +
              this.availableFileFormatsToImport,
              "error"
          );
          file = null;
        }
      }
    },
    getFileFormat(file) {
      var fileNameElements = file.name.split(".");
      const lastElementIndex = fileNameElements.length - 1;
      var fileFormat = fileNameElements[lastElementIndex];
      return fileFormat;
    },
    isFileFormatAvailable(fileFormat) {
      var formatAvailable = false;
      for (var i = 0; i < this.availableFileFormatsToImport.length; i++) {
        if (
            this.availableFileFormatsToImport[i].toLowerCase() ===
            fileFormat.toLowerCase()
        ) {
          formatAvailable = true;
          break;
        }
      }
      return formatAvailable;
    },
    sheetIsSelected() {
      this.importActionButtonDisabled = false;
    },
    addSheet() {
      this.sheets.push({name: this.sheetName, data: [...this.collection]});
      this.sheetName = null;
    },

    closeFieldsBindingForm() {
      this.xlsxContentDisplayed = false;
      this.xlsxDataParsing = false;
      log.log("Zapisuję mapowanie...")
      log.log(this.jsonKeyMap)
    },
    cancelMapping() {
      this.columnsMapping = {};
      this.closeFieldsBindingForm();
    },

    reverseObjectKeyValue(data) {
      return Object.fromEntries(
          Object
              .entries(data)
              .map(([key, value]) => [value, key])
      );
    },
    initColumnMappingDialog() {
      return this.commonModule.httpGetCategoryTreeFileKeyMap()
          .then((response) => {
            this.excelFileAvailableKeysMap = JSON.parse(JSON.stringify(response.data.payload));
            this.excelFileAvailableKeysMapReversed = this.reverseObjectKeyValue(this.excelFileAvailableKeysMap);
          // base on selected this.preferredIdentifier user will have only some of available column kays to map
            if(this.preferredIdentifier === "ID") {
             // remove keys guid,parentCategoryGuid,parentCategoryPath from excelFileAvailableKeysMap and excelFileAvailableKeysMapReversed
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["guid"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["parentCategoryGuid"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["parentCategoryPath"]];
              delete this.excelFileAvailableKeysMap["guid"];
              delete this.excelFileAvailableKeysMap["parentCategoryGuid"];
              delete this.excelFileAvailableKeysMap["parentCategoryPath"];

            }else if(this.preferredIdentifier === "GUID") {
              // remove keys id,parentCategoryId,parentCategoryPath from excelFileAvailableKeysMap and excelFileAvailableKeysMapReversed
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["id"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["parentCategoryId"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["parentCategoryPath"]];
              delete this.excelFileAvailableKeysMap["id"];
              delete this.excelFileAvailableKeysMap["parentCategoryId"];
              delete this.excelFileAvailableKeysMap["parentCategoryPath"];
            }else if(this.preferredIdentifier === "NAME") {
              // remove keys id, guid,parentCategoryId,parentCategoryGuid from excelFileAvailableKeysMap and excelFileAvailableKeysMapReversed
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["id"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["guid"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["parentCategoryId"]];
              delete this.excelFileAvailableKeysMapReversed[this.excelFileAvailableKeysMap["parentCategoryGuid"]];
              delete this.excelFileAvailableKeysMap["id"];
              delete this.excelFileAvailableKeysMap["guid"];
              delete this.excelFileAvailableKeysMap["parentCategoryId"];
              delete this.excelFileAvailableKeysMap["parentCategoryGuid"];
            }



          })
          .catch((error) => {
            apiRequestsHelper.catchResponseError(error, "httpGetCategoryTreeFileKeyMap");
          });
    },

  },
  watch: {
    preferredIdentifier(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("onPreferredIdentifierChange", newValue);


      }
    },
  },
  created() {
    // Reseting all fields
    this.sheetName = null;
    this.selectedSheet = null;
    this.sheets = [{name: "SheetOne", data: [{c: 2}]}];
    this.collection = [{a: 1, b: 2}];
    this.records = [];
    this.xlsxDataParsing = false;
    this.availableRecordsKeys = [];
    this.importActionButtonDisabled = true;
    this.xlsxContentDisplayed = false;
    this.file = null;
    this.selectSheetVisible = true;
    this.jsonKeyMap = {};
  },

};
</script>

<style scoped>
.excelImport-form {
  -webkit-box-shadow: 0px 0px 4px -2px #a0a0a0;
  box-shadow: 0px 0px 4px -2px #a0a0a0;
  margin: 10px;
  padding: 15px;
}

.excelImport-form-row {
  margin-bottom: 10px;
}

.excelImport-form-submit-row {
  width: 200px;
  padding-top: 40px;
  margin-bottom: 20px;
  margin: 5px;
}

.close-form {
  float: right;
  color: #a0a0a0;
  font-weight: 800;
}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
